import { render, staticRenderFns } from "./MedicalRequirementsPlansTable.vue?vue&type=template&id=0516165c&"
import script from "./MedicalRequirementsPlansTable.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports